module.exports = __webpack_public_path__ + "img/c08_unitclubmonkey_Normal_ua.9dfdcb75.webp";